module.exports = "/_next/static/images/428b2bc74b0d1c93598fde8cae27da76-women-md.png";